import React, { FC, useEffect } from 'react';
import './App.less';
import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import LoginScreen from '../src/screens/loginScreen/index';
import LogOutScreen from '../src/screens/loginScreen/logOut';
import { WebUx } from './screens/webux/WebUx';
import { HomePage } from './screens/home/HomePage';
import { QueryParamProvider } from 'use-query-params';
import RequestPasswordRest from './screens/RequestPasswordRest';
import RestPassword from './screens/restPassword';
import { ApplicationProvider } from './connection/ApplicationContext';
import MsalEventHandler from './MsalEventHandler';
import useSessionMonitor from './SessionMonitor';

const ScrollToTop: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window) window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App: FC = () => {
  useSessionMonitor();
  return (
    <div className="App">
      <MsalEventHandler />
      <ApplicationProvider>
        <Router>
          <ScrollToTop />
          <QueryParamProvider ReactRouterRoute={Route}>
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route exact path="/login" component={LoginScreen} />
              <Route exact path="/logout" component={LogOutScreen} />
              <Route exact path="/forget-password" component={RequestPasswordRest} />
              <Route exact path="/password-reset" component={RestPassword} />
              <Route path="/webux" component={WebUx} />
              {/*<Route path="/test" component={TestPage} />*/}
            </Switch>
          </QueryParamProvider>
        </Router>
      </ApplicationProvider>
    </div>
  );
};
export default App;
